export default {
    apiBaseUrl: 'https://dog.ceo/api'
}